<!-- eslint-disable vue/html-self-closing -->
<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->

<template>
    <div class="relative w-full">
        <!-- Dropdown Trigger -->
        <button type="button" class="base-input w-full truncate text-left" @click="toggleDropdown">
            {{ selected?.name || "Select Division" }}
        </button>
        <small v-if="checkMessage()" class="text-xs text-red-500">Please fill in your department</small>
        <input id="user_department_id" v-model="selected.id" type="hidden" name="user[department_id]" />
        <input id="user_department_name" v-model="selected.name" type="hidden" name="user[department_name]" />
        <!-- Dropdown Menu -->
        <div v-if="isOpen" class="absolute z-10 mt-2 w-full bg-white border border-gray-200 rounded-md shadow-lg">
            <ul>
                <li v-for="department in dataDepartments" :key="department"
                    class="w-full px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center justify-between">
                    <button v-if="!isEditing || editedDepartment !== department" type="button" class="w-full text-left truncate"
                        @click="selectDepartment(department)">
                        {{ department.name }}
                    </button>
                    <input v-if="isEditing && editedDepartment === department" v-model="editedDepartment.name"
                        type="text" class="base-input w-full" />
                    <button v-if="adminRole === 'true' && !isEditing && editedDepartment !== department" type="button"
                        class="ml-2 text-blue-500 hover:text-blue-700" @click.stop="editDepartment(department)">
                        Edit
                    </button>
                    <button v-if="isEditing && editedDepartment === department" type="button"
                        class="ml-2 text-blue-500 hover:text-blue-700" @click.stop="saveEditedDepartment(department)">
                        Save
                    </button>
                </li>
                <li v-if="adminRole === 'true'" class="w-full px-4 py-2">
                    <input v-model="newDepartment" type="text" placeholder="Add new department"
                        class="base-input w-full" />
                    <button type="button" class="button-cs-primary w-full mt-2" @click="addDepartment">
                        Add Department
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewDropdownDepartment',
    props: {
        // eslint-disable-next-line vue/require-default-prop
        value: String,
        // eslint-disable-next-line vue/require-default-prop
        departments: String,
        // eslint-disable-next-line vue/require-default-prop
        accountId: String,
        errorMessage: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: []
        },
        // eslint-disable-next-line vue/require-default-prop
        adminRole: String
    },
    emits: ['input'],
    data() {
        return {
            isOpen: false,
            isEditing: false,
            selected: JSON.parse(this.value),
            newDepartment: null,
            editedDepartment: null,
            dataDepartments: JSON.parse(this.departments)
        }
    },
    methods: {
        toggleDropdown() {
            if (this.adminRole === 'true') {
                this.isOpen = !this.isOpen
            }
        },
        selectDepartment(department) {
            this.selected = department // Update the displayed value
            this.isOpen = false // Close dropdown
            this.$emit('input', department) // Emit the value to the parent
        },
        addDepartment() {
            if (this.newDepartment.trim() !== '') {
                this.dataDepartments.push({ account_id: this.accountId, name: this.newDepartment.trim() })
                this.newDepartment = '' // Clear input
            }
        },
        editDepartment(department) {
            this.isEditing = true
            this.editedDepartment = department
        },
        saveEditedDepartment(department) {
            const index = this.dataDepartments.findIndex(d => d.id === department.id)
            const payload = { department: { name: this.editedDepartment.name } }

            fetch(`/departments/${department.id}.json`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
                },
                credentials: 'same-origin',
                body: JSON.stringify(payload)
            }).then(response => {
                if (!response.ok) throw new Error('Update failed')
                return response.json()
            }).then(updated => {
                if (index !== -1) this.dataDepartments[index] = updated
                if (this.selected?.id === updated.id) this.selected = updated
                this.isEditing = false
                this.editedDepartment = null
            }).catch(() => {
                window.alert('Failed to update division. Please try again.')
                this.isEditing = false
                this.editedDepartment = null
            })
        },
        checkMessage() {
            return this.errorMessage && this.errorMessage.join().includes('epartment')
        }
    }
}
</script>
